import { Hero } from "./sections/Hero";
import { MigrationCards } from "./sections/MigrationCards";
import { FAQ } from "./sections/FAQ";
import { CtaBanner } from "./sections/CtaBanner";
import { Footer } from "./sections/Footer";

function App() {
    return (
        <div className="page">
            <Hero />
            <MigrationCards />
            <FAQ>
                <CtaBanner />
            </FAQ>
            <Footer />
        </div>
    );
}

export default App;
